import { useAuth } from "../../lib/useAuth"
import { editJts3User } from "../../services/jts3Apis"
import { useEffect, useState } from "react"

const AutoRenewButton = ({ jts3User }) => {
    const [isChecked, setIsChecked] = useState()

    let debounceTimeout

    useEffect(() => {
        if (jts3User) {
            setIsChecked(jts3User.autorenew)
        }
    }, [jts3User])

    const onChangeHandler = (e) => {
        const checked = e.target.checked
        setIsChecked(!isChecked)

        if (debounceTimeout) {
            debounceTimeout = null
        }

        debounceTimeout = setTimeout(() => {
            editJts3User({
                userId: jts3User.id,
                autorenew: checked,
            })
        }, 500)
    }

    return (
        <div className="flex my-1" dir="rtl">
            <label class="relative inline-flex items-center cursor-pointer">
                <input
                    onChange={onChangeHandler}
                    type="checkbox"
                    name="autorenew"
                    class="sr-only peer"
                    checked={isChecked}
                />
                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none  peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
            </label>
        </div>
    )
}

export default AutoRenewButton
